export const CHECK_GEOLOCATION_PERMISSION_INTERVAL = 5000;
export const CHECK_NOTIFICATIONS_PERMISSION_INTERVAL = 5 * 60000;
export const CHECK_PERMISSIONS_INTERVAL = 10000;
export const GET_EVENTS_INVITATIONS_INTERVAL = 30000;
export const GET_FRIENDS_INTERVAL = 15000;
export const GET_FRIENDS_REQUESTS_INTERVAL = 30000;
export const GET_NOTIFICATIONS_INTERVAL = 30000;
export const GET_USER_RELATED_EVENTS_INTERVAL = 30000;
export const GET_USERS_AND_EVENTS_INTERVAL = 10000;
export const SEND_LOCATION_INTERVAL = 10000;